import { render, staticRenderFns } from "./customer_contacts.vue?vue&type=template&id=485c8d1e&scoped=true&"
import script from "./customer_contacts.vue?vue&type=script&lang=js&"
export * from "./customer_contacts.vue?vue&type=script&lang=js&"
import style0 from "./customer_contacts.vue?vue&type=style&index=0&id=485c8d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485c8d1e",
  null
  
)

export default component.exports